import { Badge, Button, Col, Modal, ModalBody, Row } from 'reactstrap';
import { Icon, RSelect } from '../../../components/Component';
import { useEffect, useState } from 'react';
import { activeStatus, Languages, newRoles, validateEmail, validatePassword } from '../../../utils/envConfig';
import { toast } from 'react-toastify';
import { isPossiblePhoneNumber, isValidPhoneNumber } from 'react-phone-number-input';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import PhoneInput from '../../../components/input/contact-input/PhoneInput';
import { splitCamelCase } from '../../../utils/Utils';
import ChannelPartnersFilter from '../../components/filter-components/ChannelPartnersFilter';

const AddPartnerAgent = ({ isOpen, toggleModal, refresh, isChannelPartnerManager }) => {
  const axios = useAxiosPrivate();
  const { myerrors, register, handleSubmit } = useForm();
  const navigate = useNavigate();

  const authUser = useSelector((state) => state?.user?.loggedInUser);

  const [user, setUser] = useState(null);
  const [saveLoading, setSaveLoading] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [errorX, setErrorX] = useState(null);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [cpassword, setCPassword] = useState('');
  const [language, setLanguage] = useState([]);
  const [rera, setRERA] = useState('');
  const [ded, setDED] = useState('');
  const [permit, setPERMIT] = useState('');
  const [rics, setRICS] = useState(false);
  const [bio, setBio] = useState('');

  const [errors, setErrors] = useState({});

  const [languageOptions, setLanguageOptions] = useState([]);

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    active: activeStatus[0],
    role: newRoles.ChannelPartnerAgent,
    leaderId: undefined,
    partner: undefined,
    allRoles: []
  });

  const resetForm = () => {
    setFormData({
      firstName: undefined,
      lastName: undefined,
      email: undefined,
      phone: undefined,
      active: activeStatus[0],
      role: undefined,
      leaderId: undefined,
      partner: undefined
    });
    setUser(null);
  };

  const onFormCancel = () => {
    toggleModal();
    resetForm();
  };

  const validate = (firstName, lastName, email, password, cpassword, role) => {
    let isError = false;
    if (firstName.length < 2) {
      toast.error('Enter valid First Name');
      isError = true;
    }

    if (lastName.length < 2) {
      toast.error('Enter valid Last Name');
      isError = true;
    }

    if (!validateEmail(email)) {
      isError = true;
      toast.error('Enter valid email address');
    }

    if (!phoneNumber || !phoneNumber.trim()) {
      isError = true;
      toast.error('Enter valid phone number');

      const isPossiblePhone = isPossiblePhoneNumber(phoneNumber, 'AE');

      if (isPossiblePhone) {
        isError = true;
        const isValidNum = isValidPhoneNumber(phoneNumber, 'AE');

        if (isValidNum) {
          isError = false;
        }
      } else {
        isError = true;
        toast.error('Phone number is not possible');
      }
    }

    if (!validatePassword(password, cpassword)) {
      isError = true;
      // toast.error('Try with strong password');
    }
    if (!role) {
      toast.error('Select the Role');
      return false;
    }

    if ([newRoles.Agent, newRoles.ChannelPartnerAgent].includes(role)) {
      if (language.length === 0) {
        toast.error('Select Language');
        return false;
      }
    }
    return isError ? false : true;
  };

  const handleLanguage = (e) => {
    let lg = [];
    e?.forEach((language) => lg.push(language.label));
    setLanguage(lg);
  };

  const addMember = async (e) => {
    setSaveLoading(false);
    e.preventDefault();
    if (!validate(firstName, lastName, email, password, cpassword, formData.role)) {
      return;
    }

    if (!authUser) {
      toast.error('Please wait while the page fully loads.');
      return;
    }

    if (!isValidPhoneNumber(phoneNumber)) {
      setErrorX('Invalid phone number');
      return;
    }

    const addData = {
      first_name: firstName,
      last_name: lastName,
      email,
      phone: phoneNumber?.trim()?.replaceAll(' ', ''),
      password,
      active: true,
      role: formData.role,
      languages: language,
      RERANo: rera,
      DEDNo: ded,
      PERMITNo: permit,
      RICSCertified: rics,
      agentBio: bio,
      leaderId: formData.leaderId,
      lead_source: 'Employee',
      partner: authUser?.partner
    };

    try {
      setSaveLoading(true);

      const _res = await axios
        .post(`/users/createStaffWithRole`, addData)
        .then((user) => {
          if (user?.data?.id) {
            onFormCancel();
            toast.success('Agent added successfully!');
            setSaveLoading(false);
            // navigate('/partner-agents');
            refresh();
          }
        })
        .catch((err) => {
          setSaveLoading(false);
          if (err.response && err.response.data && err.response.data.message) {
            toast.error(err.response.data.message);
          } else {
            toast.error('Agent not added!');
          }
        });
    } catch (err) {
      toast.error('Server error. Try Again !');
    }
  };

  useEffect(() => {
    async function fetchLanguages() {
      let options = [];
      Languages?.forEach((item) => options.push({ label: item, value: item }));
      setLanguageOptions(options);
    }

    fetchLanguages();
  }, []);

  return (
    <Modal isOpen={isOpen} className="modal-dialog-centered" size="lg">
      <ModalBody>
        <a href="#cancel" className="close">
          {' '}
          <Icon
            name="cross-sm"
            onClick={(ev) => {
              ev.preventDefault();
              onFormCancel();
            }}
          ></Icon>
        </a>
        <div className="p-2">
          <h5 className="title">Add Agent</h5>
          <div className="mt-4">
            {/* <form onSubmit={ handleSubmit( onFormSubmit ) }> */}
            <form onSubmit={(e) => addMember(e)}>
              <Row className="g-3">
                <Col md="6">
                  <div className="form-group">
                    <label className="form-label" htmlFor="customer">
                      First Name <RedStar />
                    </label>
                    <div className="form-control-wrap">
                      <input
                        type="text"
                        className="form-control"
                        name="firstName"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        ref={register({
                          required: 'This field is required'
                        })}
                        defaultValue={''}
                      />
                      {errors.firstName && <span className="invalid">{errors.firstName}</span>}
                    </div>
                  </div>
                </Col>
                <Col md="6">
                  <div className="form-group">
                    <label className="form-label" htmlFor="customer">
                      Last Name <RedStar />
                    </label>
                    <div className="form-control-wrap">
                      <input
                        type="text"
                        className="form-control"
                        name="lastName"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        ref={register({
                          required: 'This field is required'
                        })}
                        defaultValue={''}
                      />
                      {errors.lastName && <span className="invalid">{errors.lastName}</span>}
                    </div>
                  </div>
                </Col>
                <Col md="6">
                  <div className="form-group">
                    <label className="form-label" htmlFor="customer">
                      Email <RedStar />
                    </label>
                    <div className="form-control-wrap">
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        autoComplete="off"
                        onChange={(e) => setEmail(e.target.value)}
                        ref={register({
                          required: 'This field is required'
                        })}
                        defaultValue={''}
                      />
                      {errors.email && <span className="invalid">{errors.email}</span>}
                    </div>
                  </div>
                </Col>

                <Col md="6">
                  <div className="form-group mb-2">
                    <label className="form-label" htmlFor="first-name">
                      Phone <RedStar />
                    </label>
                    <PhoneInput
                      className="phoneInput "
                      defaultCountry="AE"
                      value={phoneNumber}
                      name="phone"
                      placeholder="Enter Phone Number"
                      onChange={(value) => setPhoneNumber(value)}
                      onError={(error) => setErrorX(error)}
                    ></PhoneInput>
                    <div className="d-flex">
                      {' '}
                      {errorX && <span className="error-message text-danger">{errorX}</span>}
                    </div>
                  </div>
                </Col>
                <Col md="6">
                  <div className="form-group">
                    <label className="form-label" htmlFor="customer">
                      Password <RedStar />
                    </label>
                    <div className="form-control-wrap">
                      <input
                        type="password"
                        className="form-control"
                        name="password"
                        autoComplete="new-password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        ref={register({
                          required: 'This field is required'
                        })}
                        defaultValue={''}
                      />
                      {errors.password && <span className="invalid">{errors.password}</span>}
                    </div>
                  </div>
                </Col>

                <Col md="6">
                  <div className="form-group">
                    <label className="form-label" htmlFor="customer">
                      Confirm Password <RedStar />
                    </label>
                    <div className="form-control-wrap">
                      <input
                        type="password"
                        className="form-control"
                        name="cpassword"
                        value={cpassword}
                        onChange={(e) => setCPassword(e.target.value)}
                        ref={register({
                          required: 'This field is required'
                        })}
                        defaultValue={''}
                      />
                      {errors.password && <span className="invalid">{errors.password}</span>}
                    </div>
                  </div>
                </Col>
                <Col md="6">
                  <div className="form-group">
                    <label className="form-label" htmlFor="customer">
                      Role <RedStar />
                    </label>
                    <div className="form-control-wrap">
                      <RSelect
                        isDisabled={true}
                        defaultValue={{
                          label: formData.role ? splitCamelCase(formData.role) : '',
                          value: formData.role
                        }}
                        onChange={(e) => {
                          setFormData({ ...formData, role: e.value });
                        }}
                        options={
                          newRoles &&
                          Object.keys(newRoles).map((r) => {
                            const isDisabledRoles = [newRoles.Owner, newRoles.User, newRoles.MasterAdmin];
                            const isDisabled = isDisabledRoles.includes(newRoles[r]);
                            return {
                              label: splitCamelCase(newRoles[r]),
                              value: newRoles[r],
                              isDisabled: isDisabled
                            };
                          })
                        }
                        // isDisabled={formData.role === newRoles.Agent}
                      />
                    </div>
                  </div>
                </Col>
                {
                  <>
                    <Col md="6">
                      <div className="form-group">
                        <label className="form-label" htmlFor="regular-price">
                          Languages <RedStar />
                        </label>

                        <div className="form-control-wrap">
                          {languageOptions.length > 0 && (
                            <RSelect
                              isMulti
                              options={languageOptions}
                              onChange={(e) => handleLanguage(e)}
                              defaultValue={language?.map((lang) => ({
                                label: lang,
                                value: lang
                              }))}
                              className="customInput"
                            />
                          )}
                        </div>
                        {language &&
                          language?.map((ln, index) => (
                            <Badge key={index} className="mt-2 me-1">
                              {ln}&nbsp;
                            </Badge>
                          ))}
                      </div>
                    </Col>
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="sale-price">
                          RERA Number
                        </label>
                        <div className="form-control-wrap">
                          <input
                            type="number"
                            className="form-control"
                            name="salePrice"
                            onChange={(e) => setRERA(e.target.value)}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="6">
                      <div className="form-group">
                        <label className="form-label" htmlFor="stock">
                          PERMIT Number
                        </label>
                        <div className="form-control-wrap">
                          <input
                            type="number"
                            className="form-control"
                            name="stock"
                            onChange={(e) => setPERMIT(e.target.value)}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="6">
                      <div className="form-group">
                        <label className="form-label" htmlFor="SKU">
                          DED Number
                        </label>
                        <div className="form-control-wrap">
                          <input
                            type="text"
                            className="form-control"
                            name="sku"
                            onChange={(e) => setDED(e.target.value)}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col sm="12">
                      <div className="form-group">
                        <label className="form-label">Agent Bio</label>
                        <textarea
                          name="notes"
                          className="form-control no-resize"
                          placeholder="Agent Bio"
                          onChange={(e) => setBio(e.target.value)}
                        />
                      </div>
                    </Col>
                  </>
                }
                <Col size="12" className="text-end">
                  <Button color="primary" size="lg" disabled={saveLoading}>
                    {saveLoading ? 'Adding...' : 'Add Agent'}
                  </Button>
                </Col>
              </Row>
            </form>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

const RedStar = () => <span className="text-danger">*</span>;

export default AddPartnerAgent;
